/*@flow*/
import type { Node } from 'react';
import React, { useContext } from 'react';
import Form from './Form';
import WizardForm from './WizardForm';
import Wizard from './Wizard';
import Integration from './Integration';
import BuilderContext from './Context';
import commands from './commands';

const Component = (props: PropsT): Node => {
  const ctx = useContext(BuilderContext);
  const s = ctx.state;

  switch (s.mode) {
    case 'WIZARD':
      return <Wizard {...props} />;
    case 'WIZARD_FORM':
      return <WizardForm {...props} />;
    case 'RESOURCE_FORM':
    case 'DUP_FORM':
      return <Form {...props} />;
    case 'INTEGRATION':
      return <Integration />;
    default:
      return <Wizard {...props} />;
  }
};

export const useCommands = (): {|
  close: (opts?: { confirm: boolean, ... }) => void,
  dupResource: (o: $Shape<{ id: ID, resourceName: string, ... }>) => void,
  editResource: (o: $Shape<{ id: ID, resourceName: string, ... }>) => void,
  newResource: (
    o: $Shape<{ resource: any, resourceName: string, ... }>
  ) => void,
  open: () => void,
  reset: () => void,
  selectResource: (name: string) => void,
  set: (path: string, value: any) => void,
  setResourceKey: (key: string, value: any) => void,
  showForm: () => void,
  startIntegration: () => void,
|} => {
  const ctx = useContext(BuilderContext);
  return commands(ctx);
};

type PropsT = {
  requestClosePortal: Function,
};

export default Component;
